export { default } from '../media';
